import React from 'react';
import PropTypes from 'prop-types';
import Translate from '@hydra/common/components/i18n';
import { makeStyles } from '@material-ui/core/styles';

const googlePreview = {
  desktopTitle: '#1a0dab',
  desktopDescription: '#545454',
  mobileTitle: '#1967d2',
  mobileDescription: '#3c4043'
};

const useStyles = makeStyles(theme => ({
  googlePreviewSection: {
    breakInside: 'avoid'
  },
  googlePreviewDesktop: {
    fontFamily: 'arial',
    maxWidth: 600,
    marginTop: theme.spacing(1.5),
    marginBottom: theme.spacing(2)
  },
  googlePreviewDesktopTitle: {
    color: googlePreview.desktopTitle,
    lineHeight: '1.5em',
    fontWeight: theme.typography.fontWeightRegular,
    fontSize: theme.typography.fontSizeBase
  },
  googlePreviewDesktopUrl: {
    fontSize: theme.typography.fontSizeSmall
  },
  googlePreviewDesktopDescription: {
    color: googlePreview.desktopDescription,
    lineHeight: '1.25rem',
    fontSize: theme.typography.fontSizeSmall
  },
  googlePreviewMobile: {
    width: 342,
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(2),
    padding: theme.spacing(2, 3),
    fontFamily: 'arial',
    boxShadow: 'rgba(32, 33, 36, 0.28) 0 1px 6px',
    borderRadius: theme.shape.borderRadius * 4,
    [theme.breakpoints.down('xs')]: {
      width: '100%',
      maxWidth: 342
    }
  },
  googlePreviewMobileUrl: {
    marginLeft: theme.spacing(1.5),
    fontSize: 12,
    display: 'inline',
    wordBreak: 'break-all'
  },
  googlePreviewMobileTitle: {
    padding: theme.spacing(0.75, 0),
    color: googlePreview.mobileTitle,
    lineHeight: '1.5rem',
    fontSize: theme.typography.fontSizeBase
  },
  googlePreviewMobileDescription: {
    color: googlePreview.mobileDescription,
    lineHeight: '1.25rem',
    fontSize: theme.typography.fontSizeSmall
  }
}));

export const CriteriumGooglePreview = ({ desktop, mobile, missing, url }) => {
  const classes = useStyles();
  const faviconUrl = `https://www.google.com/s2/favicons?sz=16&domain=${url}`;

  return missing
    ? <Translate content='missing' />
    : (
      <>
        <div className={classes.googlePreviewSection}>
          <Translate content='google_preview_desktop_version' />
          <div className={classes.googlePreviewDesktop}>
            <div className={classes.googlePreviewDesktopUrl}>{desktop.url}</div>
            <div className={classes.googlePreviewDesktopTitle}>{desktop.title}</div>
            <div className={classes.googlePreviewDesktopDescription}>{desktop.description}</div>
          </div>
        </div>
        <div className={classes.googlePreviewSection}>
          <Translate content='google_preview_mobile_version' />
          <div className={classes.googlePreviewMobile}>
            <img src={faviconUrl} alt='Favicon' />
            <div className={classes.googlePreviewMobileUrl}>{mobile.url}</div>
            <div className={classes.googlePreviewMobileTitle}>{mobile.title}</div>
            <div className={classes.googlePreviewMobileDescription}>{mobile.description}</div>
          </div>
        </div>
      </>
      );
};

CriteriumGooglePreview.propTypes = {
  desktop: PropTypes.shape({
    title: PropTypes.string,
    description: PropTypes.string,
    url: PropTypes.string
  }),
  mobile: PropTypes.shape({
    title: PropTypes.string,
    description: PropTypes.string,
    url: PropTypes.string
  }),
  missing: PropTypes.bool.isRequired,
  url: PropTypes.string
};

export default CriteriumGooglePreview;
